var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 17.4392C21.0871 17.4392 21.8333 16.693 21.8333 15.7726C21.8333 14.8521 21.0871 14.1059 20.1667 14.1059C19.2462 14.1059 18.5 14.8521 18.5 15.7726C18.5 16.693 19.2462 17.4392 20.1667 17.4392Z",
    stroke: "#3B3B3B",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8332 17.4392C12.7536 17.4392 13.4998 16.693 13.4998 15.7726C13.4998 14.8521 12.7536 14.1059 11.8332 14.1059C10.9127 14.1059 10.1665 14.8521 10.1665 15.7726C10.1665 16.693 10.9127 17.4392 11.8332 17.4392Z",
    stroke: "#3B3B3B",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1665 15.7496C9.25257 15.7041 8.68242 15.5681 8.2767 15.1624C7.87097 14.7566 7.73502 14.1865 7.68946 13.2726M13.4998 15.7726H18.4998M21.8332 15.7496C22.7471 15.7041 23.3173 15.5681 23.723 15.1624C24.3332 14.5521 24.3332 13.5701 24.3332 11.6059V9.93923H20.4165C19.7961 9.93923 19.4858 9.93923 19.2348 9.85765C18.7274 9.69281 18.3296 9.29498 18.1648 8.78759C18.0832 8.53654 18.0832 8.22632 18.0832 7.6059C18.0832 6.67525 18.0832 6.20994 17.9608 5.83335C17.7135 5.07226 17.1168 4.47555 16.3558 4.22825C15.9792 4.1059 15.5138 4.1059 14.5832 4.1059H7.6665",
    stroke: "#3B3B3B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6665 7.43927H12.6665",
    stroke: "#3B3B3B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6665 9.93927H10.9998",
    stroke: "#3B3B3B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0835 5.77258H19.6012C20.814 5.77258 21.4203 5.77258 21.9138 6.06734C22.4073 6.3621 22.6948 6.89601 23.2698 7.96383L24.3335 9.93925",
    stroke: "#3B3B3B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1667 17.4392C30.0871 17.4392 30.8333 16.693 30.8333 15.7726C30.8333 14.8521 30.0871 14.1059 29.1667 14.1059C28.2462 14.1059 27.5 14.8521 27.5 15.7726C27.5 16.693 28.2462 17.4392 29.1667 17.4392Z",
    stroke: "#3B3B3B",
    strokeWidth: 1.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8332 17.4392C21.7536 17.4392 22.4998 16.693 22.4998 15.7726C22.4998 14.8521 21.7536 14.1059 20.8332 14.1059C19.9127 14.1059 19.1665 14.8521 19.1665 15.7726C19.1665 16.693 19.9127 17.4392 20.8332 17.4392Z",
    stroke: "#3B3B3B",
    strokeWidth: 1.25
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1665 15.7496C18.2526 15.7041 17.6824 15.5681 17.2767 15.1624C16.871 14.7566 16.735 14.1865 16.6895 13.2726M22.4998 15.7726H27.4998M30.8332 15.7496C31.7471 15.7041 32.3173 15.5681 32.723 15.1624C33.3332 14.5521 33.3332 13.5701 33.3332 11.6059V9.93923H29.4165C28.7961 9.93923 28.4858 9.93923 28.2348 9.85765C27.7274 9.69281 27.3296 9.29498 27.1648 8.78759C27.0832 8.53654 27.0832 8.22632 27.0832 7.6059C27.0832 6.67525 27.0832 6.20994 26.9608 5.83335C26.7135 5.07226 26.1168 4.47555 25.3558 4.22825C24.9792 4.1059 24.5138 4.1059 23.5832 4.1059H16.6665",
    stroke: "#3B3B3B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0835 5.77258H28.6012C29.814 5.77258 30.4203 5.77258 30.9138 6.06734C31.4073 6.3621 31.6948 6.89601 32.2698 7.96383L33.3335 9.93925",
    stroke: "#3B3B3B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetActive);
export default __webpack_public_path__ + "static/media/fleet-active.b2817fe1fd77298aa47a46fa653dc8cc.svg";
export { ForwardRef as ReactComponent };